<template src="./profiloUtente.html"></template>

<script>
import { get_profiloUtente, save_userAccount } from "@/api/api.user.js";

import DialogFile from "@/components/dialog/file/DialogFile.vue";

export default {
  components: {
    DialogFile,
  },

  props: {
    role: { type: String, default: "" },
  },

  data: () => ({
    activeTab: 0,
    e1: false,
    e2: false,
    dati: [],
    sconti: [],
    datiAccount: {
      Utente: "",
      PasswordAttuale: "",
      Password: "",
      PasswordRepeat: "",
      UpdateUtente: false,
      EMail: "",
    },
    showroom: null,
    alertElaborazione: "",
    tipo: "success",
    disabilitaBtnSaveAccount: false,
    validFormUtente: true,

    filePromo: [],
    dialogFile: false,
  }),

  methods: {
    async caricaDati() {
      // Reset
      this.dati = [];
      this.dialogFile = false;

      let par = "";
      let userSwitch = this.$store.getters["user/getUserSwitch"];
      if (userSwitch.Codice) par = userSwitch.Tipo + "/" + userSwitch.Codice;

      let res = await get_profiloUtente(par);
      this.dati = res.data.Profilo;
      this.datiAccount = res.data.Account;
      this.sconti = res.data.Sconti;
      this.showroom = res.data.Showroom;
      this.filePromo = res.data.FilePromozioni;

      if (this.dati == null || this.datiAccount == null) {
        this.$toast.warning("Impossibile caricare tutti i dati");
        this.showroom = [];
        return;
      }

      this.datiAccount.PasswordAttuale = "";
      this.datiAccount.Password = "";
      this.datiAccount.PasswordRepeat = "";
    },

    salvaAccount(tipo) {
      // Reset
      this.alertElaborazione = "";

      // Controllo tipo aggiornamento
      if (tipo == "nome") {
        this.datiAccount.UpdateUtente = true;

        // Validazione
        if (this.$refs.formUtente.validate() == false) {
          return;
        }
      } else if (tipo == "pwd") {
        this.datiAccount.UpdateUtente = false;

        // Validazione
        if (this.$refs.formPwd.validate() == false) {
          return;
        }
      }

      this.$root.$confirm("Salva", "Vuoi salvare i dati ?").then((confirm) => {
        if (!confirm) return;

        this.disabilitaBtnSaveAccount = true;

        // Salvo su db
        save_userAccount(this.datiAccount)
          .then((res) => {
            this.alertElaborazione =
              "Dati aggiornati. Per rendere effettive le modifiche uscire e rientrare nell'area riservata.";

            this.tipo = "success";

            this.disabilitaBtnSaveAccount = false;
          })
          .catch((err) => {
            console.log("profilo.vue " + err);
            this.disabilitaBtnSaveAccount = false;

            this.alertElaborazione = err.response.data.Message;
            this.tipo = "warning";
          });
      });
    },

    apriDocumento(file) {
      window.open(file, "_blank");
    },

    apriPdfSconti() {
      console.log(this.filePromo[0].Percorso);
      //se c'e' solo un file pdf lo apro altrimenti visualizzo la dialog di scelta
      if (this.filePromo.length == 1) {
        this.apriDocumento(this.filePromo[0].Percorso);
        return;
      }
      this.dialogFile = true;
    },

    chiudiDialogFile() {
      this.dialogFile = false;
    },
  },

  mounted: async function () {
    //aspetto qualche millisecondo cosi vue carica i dati dell'utente nello storage
    await this.$functions.delay(500);
    this.showroom = [];
    this.caricaDati();
    if (this.filePromo == null) this.filePromo = [];
  },

  computed: {
    userSwitch: function () {
      return this.$store.getters["user/getUserSwitch"];
    },
  },

  watch: {
    userSwitch() {
      this.caricaDati();
    },
  },
};
</script>